import { ScheduledReportType } from 'dashboard/enums/scheduled-report-type.enum';

export const scheduledReportTypeTranslationMap = {
    [ScheduledReportType.UNKNOWN]: 'dashboard.scheduledReports.type.unknown',
    [ScheduledReportType.LISTINGS_REPORT]: 'dashboard.scheduledReports.type.listingReport',
    [ScheduledReportType.DISTRIBUTION_TRACKING_REPORT]: 'dashboard.scheduledReports.type.distributionTrackingReport',
    [ScheduledReportType.PREMIER_INN_REPORT]: 'dashboard.scheduledReports.type.premierInnReport',
};
